import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {

  window.instancesPostPreview = [];
  
    $('.posts-preview').each(function(i) {
        var instance = tns({
            container: $(this)[0],
            autoplay: false,
            autoplayButtonOutput: false,
            speed: 1000,
            touch: true,
            controls: true,
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
            loop: false,
            gutter: 20,
            rewind: true,
            responsive: {
                1: {
                  items: 1,
                  autoplay: true,
                  autoplayTimeout: 3000,
                },
                768: {
                    items: 2,
                },
                981: {
                  items: 3,
                },
                1200: {
                    items: !$(this).data('size') || $(this).data('size') > 3 ? 4 : 3,
                },
              },
        })
        
        window.instancesPostPreview.push(instance);

        $(this).find('.first-mobile').click(function() {
          window.instancesPostPreview[i].goTo('first');
        })

        $(this).find('.next-mobile').click(function() {
            window.instancesPostPreview[i].goTo('next');
        });
    });
});



// WEBPACK FOOTER //
// ./scripts/components/posts-preview.js